import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-marine-insurance-disclaimer-card',
  templateUrl: './marine-insurance-disclaimer-card.component.html',
  styleUrls: ['./marine-insurance-disclaimer-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceDisclaimerCardComponent {
  @Input() public formGroup: UntypedFormGroup;

  public errors: any = {
    required: 'FORM_ERROR.CONFIRM_STATEMENT',
  };

  constructor(private cdr: ChangeDetectorRef) {}

  public updateTermsCheckboxValidation(): void {
    this.cdr.markForCheck();
  }
}
